import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ETagProduct, ETagType, GiftCard, GiftCardV2, Vendor } from '~models';
import { ZipYiService, GiftCardsV2Service, LoaderService, TrxService } from '~services';
import { environment } from '../../../../environments/environment';
import { EStaticCategory } from 'src/app/shared-data/giftcard-category.service';
import { ZipYiContext } from '~services/biocatch/zip-yi-context.enum';
import { ZipYiElement } from '~services/biocatch/zip-yi-element.enum';
import { GiftcardCategoryV2Service } from 'src/app/shared-data';
import { FeatureFlagService } from '~services/feature-flag/feature-flag.service';
import { Section } from '~services/trx/events';

@Component({
  selector: 'app-home-view-v2',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeViewV2Component implements OnInit {
  public giftCards: GiftCardV2[] = [];
  public featuredGiftCards: GiftCardV2[] = [];
  public searchedGiftCards: GiftCardV2[];
  public zipMoneyCashbackGiftCards: GiftCardV2[] = [];
  public otherPromoGiftCards: GiftCardV2[] = [];
  public appPrefix = environment.appPrefix;
  public env = environment.environment;
  public featured: string[] = [];
  public categories = [];
  public categoryFilterGiftCards: GiftCardV2[] = [];
  public staticCategory = EStaticCategory;
  public zipYiElement = ZipYiElement;
  public showMaintenanceMessage = false;

  constructor(
    private giftCardV2Service: GiftCardsV2Service,
    private ngRouter: Router,
    public giftcardCategoryV2Service: GiftcardCategoryV2Service,
    private zipYiService: ZipYiService,
    private loaderService: LoaderService,
    private trxService: TrxService,
    private featureFlagService: FeatureFlagService,
  ) {}

  async ngOnInit() {
    try {
      this.loaderService.show(`We're fetching your Gift Cards.`);
      await this.getCards();
      this.loaderService.hide();
    } catch (error) {
      this.loaderService.hide();
      window.zbm?.reportError(error);
      this.ngRouter.navigate(['/error/unavailable']);
    }
    this.zipYiService.setContext(ZipYiContext.HomePage);
    this.trxService.sectionStartEvent(Section.GiftcardHub);
  }

  async getCards() {
    [this.giftCards, this.featured, this.categories] = await Promise.all([
      this.giftCardV2Service.getCards(),
      this.giftCardV2Service.getFeaturedCards(),
      this.giftCardV2Service.getCardCategories(),
    ]);

    // TODO remove once shop central is 100% switched over
    if (!this.featureFlagService.isShopCentralEnabled) {
      // filter and sort zip money specific cashback card
      this.zipMoneyCashbackGiftCards = this.giftCards
        .filter((c) =>
          c.tags?.find(
            (t) =>
              t.type === ETagType.CASHBACK &&
              t.products?.length === 1 &&
              t.products[0] === ETagProduct.ZM,
          ),
        )
        .sort((a, b) => a.brand.localeCompare(b.brand));

      // filter and sort non-zip-money promo card
      this.otherPromoGiftCards = this.giftCards
        .filter((c) =>
          c.tags?.find(
            (t) =>
              t.products?.length !== 1 ||
              (t.products?.length === 1 && t.products[0] !== ETagProduct.ZM),
          ),
        )
        .sort((a, b) => a.brand.localeCompare(b.brand));

      this.featuredGiftCards = this.giftCards.filter(
        (card) => this.featured.find((featured) => featured === card.id) !== undefined,
      );
    } else {
      this.featuredGiftCards = await this.giftCardV2Service.getShopFeaturedCards();
    }
  }

  async search() {
    this.giftcardCategoryV2Service.setSelectedCategoryId(EStaticCategory.All);
    this.searchedGiftCards = await this.giftCardV2Service.search(
      this.giftcardCategoryV2Service.searchGiftCardsInput,
    );
  }

  viewAllZipMoneyDeals() {
    this.giftcardCategoryV2Service.setSelectedCategoryId(EStaticCategory.ZipMoneyDeals);
    this.giftcardCategoryV2Service.setSearchGiftCardsInput('');
  }

  getCardBrand(card: GiftCard) {
    const AMAZON_CARD_ID = 'AUBHNAMZC001';
    return card.vendor === Vendor.DigitalGlue
      ? card.id === AMAZON_CARD_ID
        ? 'Amazon.com.au eGift Card'
        : card.brand.replace(/Store\s?card/i, '').trim()
      : card.brand;
  }
}
